var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66417 21.413C5.05551 21.8043 5.52617 22 6.07617 22H18.0762C18.6262 22 19.0972 21.8043 19.4892 21.413C19.8805 21.021 20.0762 20.55 20.0762 20V8.825C20.0762 8.55833 20.0262 8.304 19.9262 8.062C19.8262 7.82067 19.6845 7.60833 19.5012 7.425L14.6512 2.575C14.4678 2.39167 14.2555 2.25 14.0142 2.15C13.7722 2.05 13.5178 2 13.2512 2H6.07617C5.52617 2 5.05551 2.19567 4.66417 2.587C4.27217 2.979 4.07617 3.45 4.07617 4V20C4.07617 20.55 4.27217 21.021 4.66417 21.413ZM13.0762 4V8C13.0762 8.28333 13.1722 8.52067 13.3642 8.712C13.5555 8.904 13.7928 9 14.0762 9H18.0762V20H6.07617V4H13.0762ZM15.4862 10.4425L16.6362 11.5925C17.2262 12.1725 17.2262 13.1225 16.6362 13.7125L11.3462 19.0025H8.07617V15.7325L13.3662 10.4425C13.9462 9.8525 14.8962 9.8525 15.4862 10.4425ZM9.62617 17.4525H10.6562L14.1062 14.0025L13.0762 12.9725L9.62617 16.4225V17.4525Z",
    fill: "#00ACFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/iconEdit.cd2cc839436ab95d6c61b35eae47ff0f.svg";
export { ForwardRef as ReactComponent };